import { errorMessage } from "./errorMessage";

export const isEmpty = (value, ele) =>
  !value || value.length === 0 ? ele + errorMessage.isEmpty : false;
export const charatersOnly = value =>
  /^([A-Za-z]+ )+[A-Za-z]+$|^[A-Za-z]{2,32}$/.test(value);
export const digitsOnly = (value, min, max) => {
  return new RegExp(`^\\d{${min},${max}}$`).test(value);
};
export const invalidChars = (value, ele) =>
  !charatersOnly(value) ? errorMessage.invalidChars + ele : false;
export const invalidDigits = (value, ele, min, max) =>
  !digitsOnly(value, min, max) ? errorMessage.invalidDigits + ele : false;
export const invalidEmail = value => {
  const re =
    /^[a-z](([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !re.test(String(value).toLowerCase())
    ? errorMessage.invalidEmail
    : false;
};

export const isValidURL = value => {
  const res = value.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g
  );
  return res !== null;
};

export const checkPasswordContainsSpace = value => {
  const spaceRE = /^\S*$/;

  return !value ||
    value.length === 0 ||
    !spaceRE.test(String(value).toLowerCase())
    ? errorMessage.passwordContainsSpace
    : false;
};

export const invalidPassword = value => {
  const constraintRE =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#^&])[A-Za-z\d@$!%*?#^&]{8,16}$/;

  return checkPasswordContainsSpace(value)
    ? errorMessage.passwordContainsSpace
    : !constraintRE.test(value)
    ? errorMessage.invalidPassword
    : false;
};

//Check confirm password
export const checkConfirmPassword = data => {
  if (isEmpty(data.resetConfirmPassword) !== false) {
    return "Confirm Password" + errorMessage.isEmpty;
  } else if (data.resetPassword !== data.resetConfirmPassword) {
    return errorMessage.passwordMismatch;
  }
  return false;
};

export const checkVerficationCode = value => {
  const re = /^[0-9]{6}/;
  return !re.test(String(value).toLowerCase())
    ? errorMessage.invalidVerficationCode
    : false;
};

export const checkZipcode = value => {
  const re = /^\d{4,6}$/;
  return !re.test(String(value).toLowerCase())
    ? errorMessage.invalidZipcode
    : false;
};

export const validateDEA = value => {
  const re = /^[A-Z]{2}[0-9]{7}$/;

  return !re.test(value) ? errorMessage.invalidDEA : false;
};

export const isAdded = (value, ele) =>
  !value ? ele + errorMessage.isAdded : false;

export const isListAdded = (value, ele) =>
  !value.length > 0 ? ele + errorMessage.isAdded : false;

export const validAge = value =>
  Math.floor(Math.abs(Date.now() - value) / (1000 * 60 * 60 * 24)) / 365 < 18
    ? errorMessage.validAge
    : false;

export const invalidFax = value => {
  //eslint-disable-next-line
  const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  return !re.test(String(value).toLowerCase())
    ? errorMessage.invalidFax
    : false;
};

export const isTrueValue = value => {
  return value == true ? true : errorMessage.isTrueValue;
};

export const lengthChar = value => {
  return value.length <= 35 ? true : errorMessage.charLength;
};
